var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 948 212.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00ad99;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.06,208.86v-16.64c-11.88,13.67-26.44,20.2-42.48,20.2C28.22,212.43,0,185.69,0,136.96S27.63,61.8,63.58,61.8c15.75,0,30.9,6.24,42.48,20.5V10.7h45.46v198.17h-45.46Zm0-49.91v-43.97c-5.94-7.73-17.83-12.78-27.63-12.78-18.12,0-31.49,13.37-31.49,34.76s13.37,35.06,31.49,35.06c9.8,0,21.69-5.35,27.63-13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m269.76,208.86v-14.26c-8.91,10.7-26.15,17.83-44.57,17.83-21.99,0-49.32-14.85-49.32-47.24,0-34.76,27.33-46.05,49.32-46.05,19.01,0,35.95,5.94,44.57,16.64v-17.23c0-12.48-10.7-20.8-29.12-20.8-14.26,0-29.12,5.35-40.7,15.15l-16.34-28.82c18.42-15.75,43.08-22.28,65.07-22.28,34.46,0,66.85,12.78,66.85,57.34v89.72h-45.75Zm0-36.84v-12.78c-4.75-6.54-15.45-10.1-25.55-10.1-12.18,0-22.88,5.35-22.88,16.64s10.7,16.64,22.88,16.64c10.1,0,20.8-3.57,25.55-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m345.51,26.15c0-14.56,11.59-26.15,26.15-26.15s26.14,11.59,26.14,26.15-11.59,26.44-26.14,26.44-26.15-11.88-26.15-26.44Zm3.27,182.72V65.36h45.75v143.5h-45.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m556.21,208.86V10.7h-51.54v153.6h-80.3v44.57h131.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m581.69,26.15c0-14.56,11.59-26.15,26.15-26.15s26.15,11.59,26.15,26.15-11.59,26.44-26.15,26.44-26.15-11.88-26.15-26.44Zm3.27,182.72V65.36h45.75v143.5h-45.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m651.8,190.44l19.01-31.49c10.69,9.51,33.57,19.01,50.51,19.01,13.67,0,19.31-4.46,19.31-10.99,0-18.72-83.48-.3-83.48-57.93,0-25.25,21.69-47.24,61.5-47.24,24.06,0,44.57,7.73,60.01,19.01l-17.53,30.3c-8.62-8.32-24.96-15.75-42.19-15.75-10.69,0-18.12,4.46-18.12,10.4,0,16.64,83.48.3,83.48,59.12,0,27.33-24.07,47.54-65.36,47.54-25.55,0-51.99-8.62-67.14-21.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m798.26,136.96c0-41.59,31.49-75.17,76.35-75.17,42.49,0,73.38,31.2,73.38,79.92v9.8h-102.2c2.67,13.37,15.15,25.55,35.95,25.55,10.1,0,27.63-4.46,35.65-12.18l19.31,28.52c-14.26,12.78-38.03,19.01-60.02,19.01-44.27,0-78.43-28.82-78.43-75.46Zm76.35-39.81c-19.9,0-27.63,14.26-29.41,24.66h59.12c-1.19-10.1-8.62-24.66-29.71-24.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2ec8490d2c8765d73b0c58c2cfce1e1a.svg";
export { ForwardRef as ReactComponent };